<template>
  <div class="auto-code-input">
    <div class="input-wrapper">
      <el-input
        :model-value="modelValue"
        @update:model-value="handleInput"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :disabled="!isManual"
        show-word-limit
        :class="{ 'manual-mode': isManual }"
      />
      <el-button
        v-if="!isManual"
        type="primary"
        link
        @click="enableManual"
        class="edit-btn"
      >
        {{ editButtonText }}
      </el-button>
      <el-button
        v-else
        type="info"
        link
        @click="disableManual"
        class="cancel-edit-btn"
      >
        取消编辑
      </el-button>
    </div>
    <div class="field-tip" v-if="!isManual">
      {{ autoGenerateTip }}
    </div>
    <div class="field-tip manual-mode" v-else>
      <el-icon><Warning /></el-icon>
      {{ manualModeTip }}
    </div>
  </div>
</template>

<script setup>
import { ElMessage, ElMessageBox } from 'element-plus'
import { Warning } from '@element-plus/icons-vue'

const props = defineProps({
  // 双向绑定的值
  modelValue: {
    type: String,
    default: ''
  },
  // 是否为手动模式
  isManual: {
    type: Boolean,
    default: false
  },
  // 自动生成提示
  autoGenerateTip: {
    type: String,
    default: '自动生成'
  },
  // 手动模式提示
  manualModeTip: {
    type: String,
    default: '手动编辑模式：修改后将不再自动更新'
  },
  // 编辑按钮文字
  editButtonText: {
    type: String,
    default: '编辑代码'
  },
  // 输入框占位符
  placeholder: {
    type: String,
    default: '自动生成'
  },
  // 最大长度
  maxlength: {
    type: [Number, String],
    default: 50
  },
  // 确认取消的提示信息
  cancelConfirmMessage: {
    type: String,
    default: '取消手动编辑后，将恢复自动生成。确定要取消吗？'
  }
})

const emit = defineEmits(['update:modelValue', 'update:isManual', 'manualEnabled', 'manualDisabled'])

// 处理输入
const handleInput = (value) => {
  emit('update:modelValue', value)
}

// 启用手动编辑
const enableManual = () => {
  emit('update:isManual', true)
  emit('manualEnabled')
  ElMessage.info('已启用手动编辑模式')
}

// 取消手动编辑
const disableManual = async () => {
  try {
    await ElMessageBox.confirm(
      props.cancelConfirmMessage,
      '确认取消',
      {
        type: 'warning',
        confirmButtonText: '确定取消',
        cancelButtonText: '继续编辑'
      }
    )
    emit('update:isManual', false)
    emit('update:modelValue', '') // 清空值，让父组件重新生成
    emit('manualDisabled')
    ElMessage.success('已恢复自动生成模式')
  } catch (error) {
    // 用户取消操作，不做任何处理
  }
}
</script>

<style scoped>
.auto-code-input {
  width: 100%;
}

.input-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.input-wrapper .el-input {
  flex: 1;
}

.edit-btn,
.cancel-edit-btn {
  white-space: nowrap;
}

.field-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.field-tip.manual-mode {
  color: #e6a23c;
  display: flex;
  align-items: center;
  gap: 4px;
}

.field-tip.manual-mode .el-icon {
  font-size: 14px;
}

/* 手动模式下的输入框样式 */
:deep(.manual-mode .el-input__inner) {
  border-color: #e6a23c;
  background-color: #fdf6ec;
}
</style>